<template>
    <div class="thingsAdmin">
        <div class="tabCont">
            <el-tabs
                v-model="searchForm.status"
                type="border-card"
                @tab-click="commodity"
                ref="tabs"
            >
                <el-tab-pane
                    v-for="item in statusList"
                    :key="item.status"
                    :name="item.status"
                >
                    <span slot="label" class="label">
                        <!-- <i class="el-icon-box"></i> -->{{ item.name }}
                        {{ item.total }}</span
                    >
                </el-tab-pane>
            </el-tabs>
        </div>
        <div class="searchCont">
            <div class="searchContLeft">
                <el-form
                    :inline="true"
                    :model="searchForm"
                    label-width="120"
                    @keydown.enter.native="commodity"
                >
                    <el-form-item label="资产编号" size="mini">
                        <el-input
                            clearable
                            placeholder="请输入资产编号"
                            size="mini"
                            v-model="searchForm.serial_no"
                        >
                        </el-input>
                    </el-form-item>
                    <el-form-item label="物品名称" size="mini">
                        <el-input
                            clearable
                            placeholder="请输入物品名称"
                            size="mini"
                            v-model="searchForm.name"
                        >
                        </el-input>
                    </el-form-item>
                    <!-- <el-form-item label="状态" size="mini">
                        <el-select
                            v-model="searchForm.status"
                            filterable
                            clearable
                            size="mini"
                            placeholder="请选择状态"
                            @change="commodity"
                        >
                            <el-option
                                v-for="item in statusList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item> -->
                </el-form>
                <el-button
                    icon="el-icon-search"
                    size="mini"
                    type="primary"
                    style="margin-right: 10px"
                    @click="commodity"
                ></el-button>
                <div v-if="this.menuAuth">
                    <template v-for="item in menuAuth.slice(0, 2)">
                        <el-button
                            :type="item.class ? item.class : 'primary'"
                            :key="item.id"
                            :icon="item.icon"
                            size="mini"
                            @click="authFunc(item.funcName)"
                        >
                            {{ item.name }}
                        </el-button>
                    </template>
                    <el-dropdown
                        v-if="menuAuth.length > 2"
                        @command="authFunc"
                        style="margin-left: 10px"
                    >
                        <el-button
                            type="primary"
                            size="mini"
                            icon="el-icon-arrow-down"
                        >
                            更多操作
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item
                                :key="item.id"
                                v-for="item in menuAuth.slice(2)"
                                :command="item.funcName"
                                style="font-size: 12px"
                            >
                                <i :class="item.icon"> </i>
                                {{ item.name }}
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div v-else></div>
            </div>
            <!-- 高级搜索 -->
            <advancedSearch :drawerVisible.sync="drawerVisible"
                >高级搜索</advancedSearch
            >
        </div>
        <el-drawer
            title="高级搜索"
            :visible.sync="drawerVisible"
            size="320px"
            class="drawerCont"
            ref="drawer"
            :wrapperClosable="false"
        >
            <el-scrollbar class="scrollbar">
                <el-form
                    :model="searchForm"
                    class="drawerForm"
                    label-width="120"
                >
                    <el-form-item label="使用部门" size="small">
                        <!-- <selectbutton
                            :props="props"
                            :options="optionData"
                            :value="searchForm.depart_id"
                            :clearable="isClearable"
                            :accordion="isAccordion"
                            @getValue="getValue($event)"
                            height="200"
                            ref="selectBtn"
                            :placeholder="'请选择使用部门'"
                        ></selectbutton> -->
                        <el-cascader
                            clearable
                            :options="departList"
                            :props="props"
                            v-model="searchForm.depart_list"
                            style="width: 100%"
                            placeholder="请选择所在部门"
                        >
                        </el-cascader>
                    </el-form-item>
                    <el-form-item label="使用员工" size="small">
                        <el-select
                            v-model="searchForm.user_id"
                            filterable
                            clearable
                            multiple
                            collapse-tags
                            size="small"
                            placeholder="请选择使用员工"
                        >
                            <el-option
                                v-for="item in staffList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="购买时间" size="small">
                        <el-date-picker
                            v-model="searchForm.purchase_time"
                            prefix-icon="el-icon-date theme-color"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="一"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            @change="commodity"
                            value-format="yyyy-MM-dd"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item style="text-align: right">
                        <el-button
                            type="danger"
                            icon="el-icon-refresh-right"
                            size="small"
                            @click="clean"
                        >
                            重置条件
                        </el-button>
                    </el-form-item>
                </el-form>
            </el-scrollbar>
            <div class="drawer-footer">
                <el-button
                    style="width: 100%"
                    type="primary"
                    icon="el-icon-search"
                    size="small"
                    @click="commodity"
                >
                    查询
                </el-button>
                <!-- <el-button
                    type="danger"
                    icon="el-icon-circle-close"
                    size="small"
                    @click="clean"
                >
                    清空
                </el-button> -->
            </div>
        </el-drawer>

        <div class="table" :style="{ height: screen }">
            <el-table
                :data="tableData"
                highlight-current-row
                height="100%"
                @selection-change="handleSelectionChange"
            >
                <el-table-column
                    type="selection"
                    align="center"
                    :fixed="checkFixed"
                ></el-table-column>
                <el-table-column
                    label="资产编号"
                    align="left"
                    property="serial_no"
                >
                </el-table-column>
                <el-table-column
                    label="物品名称"
                    align="left"
                    property="name"
                    show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column label="单位" align="left" property="unit">
                </el-table-column>

                <el-table-column label="购买数量" property="qty" align="left">
                </el-table-column>
                <el-table-column
                    label="购买金额"
                    property="price"
                    align="left"
                >
                </el-table-column>
                <el-table-column
                    label="购买时间"
                    property="purchase_time"
                    align="left"
                >
                </el-table-column>
                <el-table-column
                    label="使用部门"
                    property="depart_name"
                    align="left"
                >
                    <template slot-scope="scoped">
                        <el-tooltip
                            effect="dark"
                            :content="scoped.row.full_depart_name"
                            placement="top"
                            v-if="scoped.row.full_depart_name"
                        >
                            <span class="cursor_pointer">{{
                                scoped.row.depart_name
                            }}</span>
                        </el-tooltip>
                        <span class="cursor_pointer" v-else>{{
                            scoped.row.depart_name
                        }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="当前状态" align="left" width="100">
                    <template slot-scope="scope">
                        <el-tag
                            size="mini"
                            :type="
                                scope.row.status == 1
                                    ? 'warning'
                                    : scope.row.status == 2 ||
                                      scope.row.status == 4
                                    ? 'info'
                                    : scope.row.status == 3
                                    ? 'danger'
                                    : ''
                            "
                        >
                            {{ scope.row.status_cn }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                    label="使用员工"
                    property="user_name"
                    align="left"
                >
                </el-table-column>
                <el-table-column
                    label="创建时间"
                    property="create_time"
                    align="left"
                    width="160"
                >
                </el-table-column>
                <el-table-column
                    label="操作"
                    align="left"
                    width="200"
                    :fixed="operationFixed"
                >
                    <template slot-scope="scope">
                        <div class="operation-btns">
                            <span
                                v-for="item in scope.row.authority"
                                :key="item.id"
                            >
                                <el-button
                                    v-if="item.status_flag != 4"
                                    type="text"
                                    size="small"
                                    class="color-blue"
                                    :class="
                                        item.name == '删除' ? 'redText' : ''
                                    "
                                    @click="rowDo(scope.row, item)"
                                    >{{ item.name }}</el-button
                                >
                                <!-- <el-popconfirm
                                    v-else
                                    :title="'确定' + item.name + '?'"
                                    @onConfirm="rowDo(scope.row, item)"
                                >
                                    <el-button
                                        slot="reference"
                                        type="text"
                                        size="small"
                                        :class="
                                            item.name == '删除' ? 'redText' : ''
                                        "
                                        >{{ item.name }}</el-button
                                    >
                                </el-popconfirm> -->
                                <popConfirm
                                    v-else
                                    :title="item.name"
                                    :buttonText="item.name"
                                    @confirm="rowDo(scope.row, item)"
                                >
                                </popConfirm>
                            </span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <pagination
            :paginationData="paginationData"
            @paginationChange="paginationChange"
        ></pagination>
        <importPublic
            :importVisible.sync="importVisible"
            :parentFuncName="'commodity'"
            :methodName="'commodityImport'"
            :temSrc="'/v1/commodity/download-tpl'"
        ></importPublic>
        <add :addVisible.sync="addVisible"></add>
        <edit :editVisible.sync="editVisible" :tableItem="tableItem"></edit>
        <detail
            :detailVisible.sync="detailVisible"
            :tableItem="tableItem"
        ></detail>
    </div>
</template>
<script>
import * as api from "@/http/api.js";
import * as oaApi from "@/http/oaApi.js";
import { tableMixin } from "@/utils/tableMixins.js";
import pagination from "@/comon/components/pagination";
import importPublic from "@/comon/components/importPublic";
import add from "./thingsAdmin/add";
import edit from "./thingsAdmin/edit";
import detail from "./thingsAdmin/detail";
import selectbutton from "@/comon/components/selectbutton";
import advancedSearch from "@/comon/components/advancedSearch";
import popConfirm from "@/comon/components/popConfirm";
import { mapState, mapActions } from "vuex";
export default {
    mixins: [tableMixin],
    data() {
        return {
            searchForm: {
                name: "",
                depart_list: "",
                user_id: "",
                purchase_time: "",
                status: "",
            },
            tableData: [],
            countryList: [],

            paginationData: {
                page: 1,
                "per-page": 20,
                total: "",
            },
            addVisible: false,
            editVisible: false,
            detailVisible: false,
            importVisible: false,
            tableItem: {},
            drawerVisible: false,
            selectList: [],

            isClearable: false, // 可清空（可选）
            isAccordion: true, // 可收起（可选）
            valueId: "", // 初始ID（可选）
            /* props: {
                // 配置项（必选）
                value: "id",
                label: "name",
                children: "child"
                // disabled: true
            }, */
            // 选项列表（必选）
            departList: [],
            props: {
                value: "id",
                label: "name",
                children: "child",
                checkStrictly: true,
            },
            statusList: [],
        };
    },
    components: {
        pagination: pagination,
        importPublic: importPublic,
        popConfirm: popConfirm,
        add: add,
        edit: edit,
        detail: detail,
        selectbutton: selectbutton,
        advancedSearch: advancedSearch,
    },
    methods: {
        commodity(page) {
            page ? (this.paginationData.page = 1) : "";
            oaApi
                .commodity(
                    {
                        ...this.paginationData,
                        ...this.searchForm,
                        menu_id: this.menu_id,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.statusList = res.ext.tabs;
                        this.tableData = res.data;
                        this.paginationData.total = res.total;
                        this.closeDrawer();
                    }
                });
        },
        paginationChange(paginationData) {
            this.paginationData = paginationData;
            this.commodity();
        },
        /**
         *  获取组织架构信息
         */
        depart() {
            api.depart({}, "get").then((res) => {
                if (res) {
                    this.departList = res.data;
                }
            });
        },
        resetTabActivePosition($el) {
            var activeEl = $el.querySelector(".el-tabs__item.is-active");
            var lineEl = $el.querySelector(".el-tabs__active-bar");
            if (activeEl) {
                var style = getComputedStyle(activeEl);
                var pl = style.paddingLeft.match(/\d+/)[0] * 1;
                var pr = style.paddingRight.match(/\d+/)[0] * 1;
                var w = style.width.match(/\d+/)[0] * 1;
                lineEl.style.transform =
                    "translateX(" + (activeEl.offsetLeft + pl) + "px)";
                lineEl.style.width = w - pl - pr + "px";
            }
        },
        authFunc(funcName) {
            this[funcName]();
        },
        add() {
            this.addVisible = true;
        },
        import() {
            this.importVisible = true;
        },
        /**
         * table内权限按钮
         */
        rowDo(row, item) {
            if (item.name == "查看") {
                this.detailVisible = true;
                this.tableItem = row;
            } else if (item.name == "编辑") {
                this.editVisible = true;
                this.tableItem = row;
            } else if (item.name == "删除") {
                /* this.$confirm(`确定${item.name}?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => { */
                oaApi.commodity({}, "delete", row.id).then((res) => {
                    if (res) {
                        this.$message.success(`${item.name}成功`);
                    }
                    this.commodity();
                    /* })
                        .catch(() => {
                            this.$message.info("已取消操作");
                        }); */
                });
            }
        },
        clean() {
            this.searchForm = {
                name: "",
                depart_list: "",
                user_id: "",
                purchase_time: "",
                status: "",
            };
            if (this.$refs.selectBtn) {
                this.$refs.selectBtn.clearHandle();
            }
            this.commodity();
        },
        closeDrawer() {
            this.$refs.drawer.closeDrawer();
        },
        handleSelectionChange(val) {
            this.selectList = [];
            for (let i in val) {
                this.selectList.push(val[i].id);
            }
        },
        // 取值
        getValue(value) {
            this.searchForm.depart_id = value.id;
            this.commodity();
        },
        /**
         * 批量导出
         */
        commodityExport() {
            oaApi
                .commodityExport({ ids: this.selectList.toString() }, "get")
                .then((res) => {
                    if (res) {
                        window.open(res.data.url);
                    }
                });
        },
    },
    created() {
        this.depart();
        this.commodity();
    },
    watch: {
        perPage: {
            handler(newValue) {
                this.perPage = newValue;
                this.commodity();
            },
            deep: true,
            immediate: false,
        },
        page: {
            handler(newValue) {
                this.page = newValue;
                this.commodity();
            },
            deep: true,
            immediate: false,
        },
    },
    computed: {
        ...mapState({
            staffList: (state) => state.index.staffList,
            menuAuth: (state) => state.menu.menuAuth,
        }),
        screen() {
            return `calc(100% - 40px - 40px - 40px)`;
        },
        menu_id() {
            return this.$store.state.menu.menu_id
                ? this.$store.state.menu.menu_id
                : localStorage.getItem("menu_id");
        },
        /* 转树形数据 */
        /* optionData() {
            let cloneData = JSON.parse(JSON.stringify(this.departList)); // 对源数据深度克隆
            return cloneData.filter(father => {
                // 循环所有项，并添加children属性
                let branchArr = cloneData.filter(
                    child => father.id == child.parent_id
                ); // 返回每一项的子级数组
                branchArr.length > 0 ? (father.child = branchArr) : ""; //给父级添加一个children属性，并赋值
                return father.parent_id == 0; //返回第一层
            });
        } */
    },
};
</script>
<style lang="scss">
.thingsAdmin {
    height: 100%;
    background: #fff;
    width: 100%;
    box-sizing: border-box;
    padding: 0 20px;
    overflow-y: hidden;
    .table {
        width: 100%;
    }
    .el-tabs__header {
        margin: 0 !important;
    }
    .el-scrollbar__wrap {
        max-height: 4;
    }
}
</style>
